import React, { useEffect, useState } from 'react'
import CurriculumService from '../services/CurriculumService';
import { Button, Card, Col, Drawer, Form, Grid, Input, Popconfirm, Row, Switch, Tooltip } from 'antd';
import { NavLink, useNavigate } from 'react-router-dom';
import TextArea from 'antd/es/input/TextArea';
import { openNotification } from '../utils';
import { FileSearchOutlined, EditFilled, DeleteFilled } from '@ant-design/icons';

const { Item } = Form;

const Curriculum = () => {

    let navigate = useNavigate();
    const [form] = Form.useForm();
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [showAddDrawer, setShowAddDrawer] = useState(false)
    const [id, setId] = useState(null)
    const screens = Grid.useBreakpoint();

    useEffect(() => {
        getAll();
    }, []);

    useEffect(() => {
        if (!showAddDrawer) { setId(null) };
    }, [showAddDrawer])

    const getAll = () => {
        setLoading(true);
        CurriculumService.getAll().then((response: any) => {
            setData(response.data)
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    }

    const openEditModal = (item: any) => {
        setId(item.id)
        form.setFieldValue("name", item.name);
        form.setFieldValue("description", item.description);
        setShowAddDrawer(true);
    }

    const save = (values: any) => {

        let postObj = {
            "name": values.name,
            "description": values.description,
        };


        if (id) {
            CurriculumService.update(id, postObj)
                .then((response: any) => {
                    openNotification('success', 'Başarılı', 'Müfredat Başarıyla Güncellendi.')
                    getAll();
                    setShowAddDrawer(false)
                    form.resetFields();
                }).catch(() => {
                    openNotification('error', 'Başarısız', 'Müfredat Güncellenemedi.')
                });
        } else {
            CurriculumService.create(postObj)
                .then((response: any) => {
                    openNotification('success', 'Başarılı', 'Müfredat Başarıyla Eklendi.')
                    getAll();
                    setShowAddDrawer(false)
                    form.resetFields();
                }).catch(() => {
                    openNotification('error', 'Başarısız', 'Müfredat Eklenemedi.')
                });
        }
    }


    const remove = (id: number) => {
        CurriculumService.remove(id)
            .then((response: any) => {
                openNotification('success', 'Başarılı', 'Müfredat Başarıyla Silindi.')
                getAll();
                setShowAddDrawer(false)
                form.resetFields();
            }).catch(() => {
                openNotification('error', 'Başarısız', 'Müfredat Silinemedi.')
            });
    }

    const handleActiveStatusChange = (id: number, isActive: boolean) => {
        CurriculumService.updateActiveStatus(id, isActive)
            .then(() => {
                openNotification('success', 'Başarılı', `Müfredat ${isActive ? 'aktif' : 'pasif'} duruma getirildi.`);
                getAll();
            })
            .catch(() => openNotification('error', 'Başarısız', 'Müfredatın aktiflik durumu güncellenemedi.'));
    };

    return (
        <>
            <Drawer
                title="Müfredat"
                placement="right"
                width={screens.sm ? 378 : '100%'}
                onClose={() => { setShowAddDrawer(false) }}
                open={showAddDrawer}
            >
                <Form form={form} onFinish={save} layout="vertical">
                    <Item
                        name="name"
                        label="Müfredat"
                        rules={[
                            {
                                required: true,
                                message: 'Müfredat adı zorunlu',
                            }]}
                    >
                        <Input />
                    </Item>
                    <Item
                        name="description"
                        label="Açıklama"
                    >
                        <TextArea />
                    </Item>
                    <Item>
                        <Row justify={'end'} gutter={[8, 8]} className="curriculum-form-actions">
                            <Button className='btn btn-hover-dark bg-cloud font-color-onyx btn-text' onClick={() => { setShowAddDrawer(false) }}>
                                Vazgeç
                            </Button>
                            <Button className='btn btn-hover-white bg-saha-purple font-color-white fw-700 btn-text' htmlType="submit">
                                Kaydet
                            </Button>
                        </Row>
                    </Item>
                </Form>
            </Drawer>
            <Card className="curriculum-list-page" title="Müfredat Listesi" loading={loading}
                extra={<Row align={'middle'} gutter={[8, 8]} className="curriculum-page-actions">
                    <Col>
                        <Button onClick={() => { setShowAddDrawer(true) }} className='btn btn-hover-dark bg-saha-purple font-color-white btn-text'>
                            Yeni Müfredat Ekle
                        </Button>
                    </Col>
                    <Col>
                        <Button onClick={() => navigate(-1)} className='btn btn-hover-dark bg-cloud font-color-onyx  btn-text'>
                            Geri
                        </Button>
                    </Col>
                </Row>}>
                <Row gutter={[32, 32]}>
                    {data?.map((item: any, index: number) => (
                        <Col xs={24} md={12} xl={8} key={item.id ?? index}>
                            <Card className="curriculum-list-card" actions={[
                                <Tooltip key="active" title={item.isActive ? 'Müfredatı pasifleştir' : 'Müfredatı aktifleştir'}>
                                    <Switch
                                        aria-label={`${item.name} aktiflik durumu`}
                                        checked={item.isActive}
                                        checkedChildren="Aktif"
                                        unCheckedChildren="Pasif"
                                        onChange={(isActive) => handleActiveStatusChange(item.id, isActive)}
                                    />
                                </Tooltip>,
                                <Tooltip key="view" title="Müfredatı görüntüle">
                                    <NavLink aria-label="Müfredatı görüntüle" to={`/curriculums/${item.id}`}>
                                        <FileSearchOutlined />
                                    </NavLink>
                                </Tooltip>,
                                <Tooltip key="edit" title="Müfredatı düzenle">
                                    <EditFilled aria-label="Müfredatı düzenle" key="edit" onClick={() => openEditModal(item)} />
                                </Tooltip>,
                                <Popconfirm
                                    key="delete"
                                    title="Müfredatı Sil"
                                    description="Müfredatı silmek istediğinize emin misiniz?"
                                    onConfirm={() => { remove(item.id) }}
                                    okText="Evet"
                                    cancelText="Hayır"
                                >
                                    <Tooltip title="Müfredatı sil">
                                        <DeleteFilled aria-label="Müfredatı sil" />
                                    </Tooltip>
                                </Popconfirm>,
                            ]}>
                                <h3>{item.name}</h3>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Card>
        </>
    )
}

export default Curriculum
